import { trigger, animate, style, query as q, transition, AnimationMetadata } from '@angular/animations';

// Routable animations
export const slideInAnimation =
  trigger('routeAnimations', [
    transition('* <=> *', [
      style({ opacity: 0 }),
      animate('500ms ease-in-out', style({ opacity: 1 }))
    ])
  ]);
